import { render, staticRenderFns } from "./modalProducto.vue?vue&type=template&id=2d1a2e06&"
import script from "./modalProducto.vue?vue&type=script&lang=js&"
export * from "./modalProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports